import React, { Component } from "react";
import {
  mediaType,
  mediaStatus
} from "WEBSOCKET/constants";
import { isIE } from "react-device-detect";

import { getMessage } from "CONFIG/i18n";
import { audioVideoAction } from "CONFIG/ActionFactory";
import { wsocket } from "WEBSOCKET/wsocket";

import ic_call_cut from "ASSETS/Images/video_menu/ic_call_cut_filled.svg";
import audio_off from "ASSETS/Images/video_menu/ic_audio_off_small.svg";
import audio_on from "ASSETS/Images/video_menu/ic_audio_on_small.svg";
import video_on from "ASSETS/Images/video_menu/ic_video_on_small.svg";
import video_off from "ASSETS/Images/video_menu/ic_video_off_small.svg";
import ic_reverse_camera_on from "ASSETS/Images/video_menu/ic_camera_reverse_on.svg";

export default class IconsPositionBar extends Component {
  render(){
    return(
      <div
        className={this.props.parentClassname}>
        <div
          id={"iconsPosition" + this.props.participant.uniqueId}
          className={"positionIcons audioVideoCallIcons " + this.props.className}
          // {this.props.componentInFocus == COMPONENT_IN_FOCUS.AUDIO_VIDEO
          //   ? "annotationBar setBackground"
          //   :"positionIcons"}
        >
          <div className={this.props.iconsDivClassname}>
            { !this.props.hideButton &&
              <img
                className={this.props.participant.uniqueId === this.props.uniqueId ?
                  "audioIcon cursorPointer pl-1" :
                  "audioIcon cursorDisabled pl-1"
                }
                onClick={(e) => {
                  // restrict click of audio/video box
                  e.stopPropagation()
                  if(this.props.participant.uniqueId === this.props.uniqueId) {
                    if(!isIE) {
                      let sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["AUDIO"].peerConnection.getSenders().find(function (s) {
                        return s.track.kind == 'audio';
                      });
                      if(sender && sender.track) {
                      // if audioStatus is muted enable audio for unmuting
                        sender.track.enabled = this.props.participant.audioStatus === mediaStatus.MUTED
                          || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT ? true : false;
                        console.log('AUDIO sender.track.enabled: ', sender.track.enabled);
                      }
                    }
                    audioVideoAction.setParticipantMediaStatus({
                      uniqueId: this.props.uniqueId,
                      audioStatus: this.props.participant.audioStatus === mediaStatus.MUTED
                      || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT
                        ? mediaStatus.UNMUTED
                        : mediaStatus.MUTED
                    });
                    audioVideoAction.toggleMedia(
                      this.props.sessionKey,
                      mediaType.AUDIO,
                      (this.props.participant.audioStatus === mediaStatus.MUTED
                        || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT) 
                        ? mediaStatus.UNMUTED 
                        : mediaStatus.MUTED,
                      this.props.participant.uniqueId
                    );
                  } 
                }}
                src={(this.props.participant.audioStatus === mediaStatus.MUTED
                  || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT)
                  ? audio_off
                  : audio_on
                }
                title={
                  this.props.participant.uniqueId === this.props.uniqueId
                    ? (this.props.participant.audioStatus === mediaStatus.MUTED
                    || this.props.participant.audioStatus === mediaStatus.MUTED_BY_AGENT)
                      ? getMessage("UNMUTE_AUDIO")
                      : getMessage("MUTE_AUDIO")
                    : ""
                }
              />
            }
            {
              !this.props.hideButton && this.props.participant.mediaType === mediaType.AUDIO_VIDEO && (
                <img
                  className=
                    {this.props.participant.uniqueId === this.props.uniqueId 
                      ? "videoIcon cursorPointer pl-1"
                      : "videoIcon cursorDisabled pl-1"
                    }
                  onClick={(e) => {
                    // restrict click of audio/video box
                    e.stopPropagation()
                    if (this.props.participant.uniqueId === this.props.uniqueId) {
                      if(!isIE) {
                        let sender = wsocket.audioAndVideoRtcPeer[this.props.uniqueId]["VIDEO"].peerConnection.getSenders().find(function (s) {
                          return s.track.kind == 'video';
                        });
                        if(sender && sender.track) {
                        // if videoStatus is muted enable video for unmuting
                          sender.track.enabled = this.props.participant.videoStatus === mediaStatus.MUTED
                            || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT ? true : false;
                          console.log('VIDEO sender.track.enabled: ', sender.track.enabled);
                        }
                      }
                      audioVideoAction.setParticipantMediaStatus({
                        uniqueId: this.props.uniqueId,
                        videoStatus: this.props.participant.videoStatus === mediaStatus.MUTED
                        || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT
                          ? mediaStatus.UNMUTED
                          : mediaStatus.MUTED
                      });
                      audioVideoAction.toggleMedia(
                        this.props.sessionKey,
                        mediaType.AUDIO_VIDEO,
                        (this.props.participant.videoStatus === mediaStatus.MUTED
                          || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT) 
                          ? mediaStatus.UNMUTED 
                          : mediaStatus.MUTED,
                        this.props.participant.uniqueId
                      )
                    } 
                  }}
                  src={
                    (this.props.participant.videoStatus === mediaStatus.MUTED
                    || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT)
                      ? video_off
                      : video_on
                  }
                  title={this.props.participant.uniqueId === this.props.uniqueId
                    ? (this.props.participant.videoStatus === mediaStatus.MUTED
                    || this.props.participant.videoStatus === mediaStatus.MUTED_BY_AGENT)
                      ? getMessage("UNMUTE_VIDEO")
                      : getMessage("MUTE_VIDEO")
                    : ""
                  }
                />
              )
            }
            {this.props.organiser === this.props.uniqueId && this.props.selfIcons &&
              (
                <img
                  src={ic_call_cut}
                  className="videoIcon cursorPointer px-md-1 px-0 m-0 d-none"
                  title={getMessage("END_CALL")}
                  onClick={() => {
                    this.props.isVideo ?
                      this.props.onOpenCloseEndVideoCallConfirmationModal(true) :
                      this.props.onOpenCloseEndAudioCallConfirmationModal(true);
                  }}
                />
              )
            }
          </div>
        </div>
        {(!this.props.parentClassname && this.props.participant.mediaType === mediaType.AUDIO_VIDEO && this.props.participant.isTransform) ?
          <div className={"reverseCamera d-flex " + (
            !this.props.isFlimStripContainer ? "reverseCameraTitle" : ""
          )}>
            <img
              src={ic_reverse_camera_on}
              className="px-md-1 px-0 m-0"
            />
            {
              (!this.props.isFlimStripContainer) ?
                <div>{getMessage("REVERSE_CAMERA")}</div> : null
            }
          </div> : null
        }
      </div>
    );
  }
}
